import React from "react";
import { useTranslation } from "react-i18next";
import { CircleCounter, CircleColorType } from "./CircleCounter";

interface KeywordCounterProps {
  found: number;
  total: number;
}

export const KeywordCounter: React.FC<KeywordCounterProps> = ({
  found,
  total,
}) => {
  const { t } = useTranslation(["components"]);

  return (
    <CircleCounter
      value={found}
      maxValue={total}
      label={t("components:indicators.keywordCounter.label")}
      color={CircleColorType.Blue}
      showWarning={false}
      tooltip={{
        title: t("components:indicators.keywordCounter.tooltip.title"),
        description: [
          t("components:indicators.keywordCounter.tooltip.description", {
            found,
            total,
          }),
        ],
      }}
    />
  );
};
